module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAR1JREFUOBGtkz9OQkEQh1kDCEE5AoUmhMLCwpbejhsQCwtKQsUV4AaGkobCM3gDaxNfCZyAhIQgPL8hDk4m8lwIm3yZP7/Z2d23+0LOjDRNLwkHUDdp736Q6IcQ1l7YxzRqQcx43E/6cS5couriQ+G1F3wjr0fHZ2uU44P0IYE2XMFNBBVqnuETerLtgLPCFuEdEogdDQrvYcENVqVRGjlzSd2LqX3Ab8KKRqW8Ef5zZeevpkhOIY1245gd6Rxvdzs6263Zow1ZauKXy4jbaF3VbaMpSTn3k4oZdoQ2t7ptJHn5WTu24ID/5vPyjWKv38/VeCuONBpr5kT7O583WYY83MEGssYXYh0KUNbFgzpqEWv4txr/YRNe8sznvwGUg8GTL4qSUwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/fax.png
// module id = weUC
// module chunks = 1